import { render, staticRenderFns } from "./ShopsRefreshStats.vue?vue&type=template&id=1133da72&"
import script from "./ShopsRefreshStats.vue?vue&type=script&lang=js&"
export * from "./ShopsRefreshStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports